import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('onboardingTopBar');

    return {
        LOG_OUT: t('logOut')
    };
};

export default useTranslation;
